import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

function PushToast({ id, title, body, image, duration = 6000, onClose, onClick }) {
  const { t } = useTranslation();
  const [closing, setClosing] = useState(false);

  const handleClose = useCallback((e) => {
    if (e) e.stopPropagation();
    setClosing(true);
    window.setTimeout(() => onClose(id), 200);
  }, [id, onClose]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      onClick(id);
    }
  }, [id, onClick]);

  return (
    <div
      role="alert"
      tabIndex={0}
      onClick={() => onClick(id)}
      onKeyDown={handleKeyDown}
      className={`pointer-events-auto relative flex w-[min(360px,calc(100vw-2rem))] cursor-pointer items-start gap-3 overflow-hidden rounded-2xl bg-white p-3.5 shadow-[0_8px_30px_rgba(0,0,0,0.12)] ring-1 ring-black/5 transition-all duration-200 animate-slideUp ${closing ? 'opacity-0 scale-95' : 'opacity-100 scale-100'}`}
    >
      {image ? (
        <img src={image} alt="" className="h-10 w-10 shrink-0 rounded-lg object-cover" />
      ) : null}

      <div className="min-w-0 flex-1">
        {title ? (
          <p className="truncate text-sm font-semibold text-text-main">{title}</p>
        ) : null}
        {body ? (
          <p className="mt-0.5 line-clamp-2 text-xs leading-snug text-text-accent">{body}</p>
        ) : null}
      </div>

      <button
        type="button"
        onClick={handleClose}
        aria-label={t('close')}
        className="-mr-1 -mt-1 shrink-0 rounded-lg p-1 text-text-accent transition-colors hover:bg-secondary hover:text-text-main"
      >
        <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <span
        aria-hidden="true"
        className="animate-toastProgress absolute bottom-0 left-0 h-[3px] w-full rounded-b-2xl bg-primary/60"
        style={{ animationDuration: `${duration}ms` }}
      />
    </div>
  );
}

export default PushToast;